import { resource } from '@invisible-cms/react'

export const festivalResource = <T>(
  path: string,
  model: new (props: {}) => T,
  normalize?: (x: T) => string,
) =>
  resource<T, { festival: string }>(
    process.env.GATSBY_BACKEND_URL + '/festival/:festival' + path,
    model,
    normalize &&
      (x => process.env.GATSBY_BACKEND_URL + '/festival/2019' + normalize(x)),
  )
